import styles from './IconDefault.module.scss';

export function IconLightBulb() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				d="M28.9882 20.9509C30.8623 18.8338 32 16.0498 32 13C32 6.37258 26.6274 1 20 1C13.3726 1 8 6.37258 8 13C8 16.0498 9.1377 18.8338 11.0118 20.9509C12.5042 22.6366 14.056 24.4539 15.0245 26.456C15.4439 27.3231 16.3277 27.9237 17.285 27.8184L23.5614 27.1284C24.2823 27.0491 24.8941 26.5802 25.2388 25.942C26.2113 24.1414 27.6246 22.4912 28.9882 20.9509Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M24.7292 27C25.6648 24.7814 27.3618 22.788 28.9882 20.9509C30.8623 18.8338 32 16.0498 32 13C32 11.5975 31.7594 10.2511 31.3172 9M24 1.68282C22.7489 1.24062 21.4025 1 20 1C13.3726 1 8 6.37258 8 13C8 16.0498 9.1377 18.8338 11.0118 20.9509C12.62 22.7674 14.2971 24.7367 15.2391 26.9254C15.5015 27.5353 16.112 27.9474 16.772 27.8748V27.8748C17.4709 27.798 18 27.2075 18 26.5044V18"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M16 32L24 31"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 35L24 34"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22.8518 37.1426L17.7676 37.7781L19 39H21L22.8518 37.1426Z"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.582 10.0003C13.3937 7.99508 14.9948 6.39386 17 5.58203"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16V18H16C14.8954 18 14 17.1046 14 16Z"
				fill="white"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M22 16C22 14.8954 22.8954 14 24 14C25.1046 14 26 14.8954 26 16C26 17.1046 25.1046 18 24 18H22V16Z"
				fill="white"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<circle
				cx="29.5"
				cy="5.66992"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="27.3301"
				cy="3.5"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="M18 18H22V24"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M5 24L4 25"
				stroke="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M35 24L36 25"
				stroke="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M2 13H1"
				stroke="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M39 13H38"
				stroke="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M4 1L5 2"
				stroke="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M36 1L35 2"
				stroke="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}
